import { render } from "./FrmManageSalesLocationDetails.vue?vue&type=template&id=0b4514fc"
import script from "./FrmManageSalesLocationDetails.vue?vue&type=script&lang=js"
export * from "./FrmManageSalesLocationDetails.vue?vue&type=script&lang=js"

import "./FrmManageSalesLocationDetails.vue?vue&type=style&index=0&id=0b4514fc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__